const toastifyLoader = () => import('react-toastify')

// helper to load the vendor dependency and call the specified method
const loadAndProxy = (name) => async (...args) => {
  const toastify = await toastifyLoader()
  return name != null
    ? toastify.toast[name](...args)
    : toastify.toast(...args)
}

// TODO: replace with es6 proxy [YF-10307]
const proxyMethodNames = ['success', 'info', 'error', 'warning', 'dark', 'warn']

// our proxy object
const toast = loadAndProxy()
proxyMethodNames.forEach((name) => {
  toast[name] = loadAndProxy(name)
})

export default toast
